import { post, get, ADDRESS } from 'lib/communication';
import { Response } from './communicationTypes';

export const generateTempLink = async (name: string, returnError: boolean = false): Promise<string> => {
    const route: string = 'file/generateTempLink';
    try {
        const response = await post<Response>(`${ADDRESS}${route}`, { name });
        if (response.ok && response.parsedBody) {
            return response.parsedBody.response;
        }
        return '';
    } catch (error) {
        console.error(error);
        return returnError ? (error as Error).message : '';
    }
};

export const uploadFile = async (file: File): Promise<string> => {
    const route: string = 'file/uploadFile';
    const formData = new FormData();
    formData.append('file', file);
    const response = await post<Response>(`${ADDRESS}${route}`, formData);
    return response.parsedBody!.response;
};

export const getFile = async (name: string): Promise<string> => {
    const route: string = 'file/getFile';
    const args: RequestInit = { cache: 'force-cache' };
    const response = await get<any>(`${ADDRESS}${route}/${name}`, args);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(new Blob([blob], { type: blob.type }));
    return url;
};
